import type {CompanyCapability,CompanyConnection,OrganizationChoice,OrganizationChoices,OwnedCompanyResource} from './types';

export function canConfirmChoice(session:OrganizationChoices|null,selectedUrn:string,resources:OwnedCompanyResource[],now:number):boolean {
  return Boolean(session&&selectedUrn&&Date.parse(session.expiresAt)>now&&
    resources.some(resource=>resource.id===session.resourceId)&&
    (!session.expectedOrganizationUrn||selectedUrn===session.expectedOrganizationUrn)&&
    session.organizations.some(choice=>choice.organizationUrn===selectedUrn));
}
export function mergeChoices(previous:OrganizationChoice[],incoming:OrganizationChoice[]):OrganizationChoice[] {
  const choices=new Map(previous.map(choice=>[choice.organizationUrn,choice]));
  for(const choice of incoming)if(choices.get(choice.organizationUrn)?.role!=='ADMINISTRATOR')choices.set(choice.organizationUrn,choice);
  return [...choices.values()];
}
export function capabilityDisplay(capability:CompanyCapability|undefined,connection:Pick<CompanyConnection,'expiresAt'|'state'>,now:number):CompanyCapability {
  const expired=connection.expiresAt&&Date.parse(connection.expiresAt)<=now;
  if(expired||['disconnected','expired','revoked'].includes(connection.state??''))return {
    ...capability,state:'needs_access',reason:expired?'Forbindelsen er udløbet. Genforbind virksomheden.':'Forbindelsen er ikke længere aktiv.',nextAction:'reconnect',
  };
  if(capability?.state==='available'&&!Number.isFinite(Date.parse(connection.expiresAt??'')))return {
    ...capability,state:'unverified',reasonCode:'token_unverified',reason:'Forbindelsens udløb er ikke bekræftet.',nextAction:'reconnect',
  };
  return capability??{state:'unverified',reason:'Adgangen er endnu ikke kontrolleret.',nextAction:'retry'};
}
export function failedCapabilityCheck(connection:CompanyConnection,checkedAt:string):CompanyConnection {
  return {...connection,capabilities:Object.fromEntries((['publish','history','analytics'] as const).map(key=>{
    const previous=connection.capabilities?.[key];
    return [key,previous?.state==='available'||!previous?{
      ...previous,state:'unverified',checkedAt,reasonCode:'check_failed',reason:'Den seneste adgangskontrol kunne ikke gennemføres.',nextAction:'retry',
    }:previous];
  })) as CompanyConnection['capabilities']};
}
export const roleLabel=(role:string)=>role==='ADMINISTRATOR'?'Administrator':'Indholdsadministrator';
export function safePageUrl(value:string|undefined):string|undefined {
  try {const url=new URL(value??'');return url.origin==='https://www.linkedin.com'&&/^\/company\/[\w-]+\/$/.test(url.pathname)&&!url.username&&!url.password?url.href:undefined}catch{return undefined}
}
export function consentUrl(value:string):string {
  const url=new URL(value);
  if(url.origin!=='https://www.linkedin.com'||url.pathname!=='/oauth/v2/authorization'||url.username||url.password)throw new Error('LinkedIn-forbindelsen kunne ikke startes. Prøv igen.');
  return url.href;
}
